/**
 * AsyncStorage keys for auth session. Single source for any version UI.
 *
 * Consumer map:
 *   - `AUTH_TOKEN_KEY` / `CURRENT_USER_KEY` → `authSessionApi`, `shared/auth/flows/*`
 *   - `STORED_LOGIN_CREDENTIALS_KEY` → `BiometricKeychain`
 *   - `BIOMETRIC_OFFER_DECIDED_KEY` → one-time enable-biometrics alert (`offerSaveBiometricLogin`)
 */
export const AUTH_TOKEN_KEY = 'authToken';
export const CURRENT_USER_KEY = 'currentUser';

/** Phone + password JSON for biometric shortcut; **not** cleared on logout. See `BiometricKeychain`. */
export const STORED_LOGIN_CREDENTIALS_KEY = 'storedLoginCredentials';

/** Set after user accepts or declines the one-time “enable biometrics” offer. */
export const BIOMETRIC_OFFER_DECIDED_KEY = 'biometricLoginOfferDecided';
